import './index.less';

import { Tabs, ToastContainer } from '@bfe/moly';
import { FC, useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';

import {
  Coin,
  // EmailSub,
  EmailSubscription,
  Notice,
  Recharge,
  Transaction,
} from './comps';
import VipNotice from './comps/VipNotice';

const tabItems = [
  // 通用
  {
    key: 'settingM.general',
    tabName: 'general',
    label: 'basicSettings',
    components: [
      {
        key: 'Coin',
        element: Coin,
      },
      {
        key: 'Transaction',
        element: Transaction,
      },
      {
        key: 'Recharge',
        element: Recharge,
        hiddenConfig: {
          identity: ['submember'],
        },
      },
    ],
  },
  // 通知
  {
    key: 'notifications',
    tabName: 'notifications',
    label: 'alertsAndNotifs',
    components: [
      {
        key: 'VipNotice',
        element: VipNotice,
        visibleConfig: {
          identity: ['regular_vip'],
        },
      },
      {
        key: 'Notice',
        element: Notice,
      },
      // {
      //   key: 'EmailSub',
      //   element: EmailSub,
      // },
    ],
  },
  // 邮箱订阅
  {
    key: 'emailSubscription',
    tabName: 'email-subscription',
    label: 'emailSubscription',
    components: [
      {
        key: 'EmailSubscription',
        element: EmailSubscription,
      },
    ],
  },
];

const Index: FC = () => {
  const [$t] = useI18nContext();
  const routes = useLocation();
  const { accountIdentity } = useUserProfile();
  const [search] = useSearchParams();
  const [activeKey, setActiveKey] = useState(tabItems[0].key);

  useEffect(() => {
    if (search.has('tab')) {
      const searchTabName = search.get('tab');
      const defaultActiveKey = tabItems.find(
        ({ tabName }) => tabName === searchTabName,
      )?.key;
      if (defaultActiveKey) {
        setActiveKey(defaultActiveKey);
      }
    }
  }, [search]);

  useEffect(() => {
    if (routes.hash === '#deposit') {
      const scrollElement: HTMLElement = document.getElementById(
        'deposit',
      ) as HTMLElement;
      window.scrollTo(0, scrollElement.offsetTop);
    }
  }, []);
  return (
    <>
      <PageHeader pageLevel={PageLevel.main} pageTitle={$t('settings')} />
      <div className="setting-container">
        <Tabs
          items={tabItems
            .map(({ components, ...item }) => {
              const visibleComponents = components?.filter(
                ({ hiddenConfig, visibleConfig }: any) => {
                  // 是否有根据用户身份进行隐藏的设置
                  if (hiddenConfig?.identity) {
                    // 如果命中隐藏则去掉该组件
                    return !hiddenConfig.identity.some((identity: string) =>
                      accountIdentity.includes(identity),
                    );
                  }
                  // 是否有根据用户身份进行显示的设置
                  if (visibleConfig?.identity) {
                    // 如果命中显示则返回该组件
                    return visibleConfig.identity.some((identity: string) =>
                      accountIdentity.includes(identity),
                    );
                  }
                  // 如果没有隐藏配置或者显示配置，则默认展示
                  return true;
                },
              );
              return {
                ...item,
                components: visibleComponents,
              };
            })
            .filter(({ components }) => {
              return components.length > 0;
            })
            .map(({ components, label, ...reset }) => {
              return {
                ...reset,
                label: $t(label),
                children: (
                  <div className="prefer-setting-container">
                    {components?.map(({ element: Element, key }) => (
                      <div className="prefer-setting-item" key={key}>
                        <Element />
                      </div>
                    ))}
                  </div>
                ),
              };
            })}
          activeKey={activeKey}
          tabTitleClassName="prefer-setting-tabs-title"
          onChange={(key) => setActiveKey(key)}
        />
        <ToastContainer />
      </div>
    </>
  );
};
export default Index;
